/* Common Imports */

import React from "react";

/* Redux Imports */

import StateInterface from "../../../../redux-magic/state-interface";
import {
	fetchSearchThunk,
	updateSearchFilterAppliedThunk,
	updateSearchFilterSelectedOptionsThunk,
} from "../../../../redux-magic/thunks";

/* Component Imports */

import { Box, CircularProgress, styled, Theme, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useRouter } from "next/router";
import { useInView } from "react-intersection-observer";
import PropertyCardGridView from "../../../cards/PropertyCardGridMiniTwo/PropertyCardFetcher";

/* Library Function Imports */

import buildDatabaseQueries from "../../../../lib/data/search-filters/helpers/buildDatabaseQueries";

/* Styled Components */

const RowDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	gap: "1rem",
	padding: "1.5rem 0rem 0rem 0rem",
	[theme.breakpoints.up("sm")]: {
		paddingTop: "1rem 0rem 0rem 0rem",
	},
}));

const DesktopFilterDivSomething = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	width: "100%",
	height: "100%",
	gap: "0.5rem",
	rowGap: "0.75rem",
	flexWrap: "wrap",
	padding: "0rem 0rem 0rem 0rem",
	/*galaxy S8+ - 360*/
	[theme.breakpoints.up(theme.breakpoints.values.xs + 78)]: {
		// gap: "0.5rem", // 3 cards
		// rowGap: "0.75rem", //3 cards
		gap: "0.75rem", // 2 cards
		rowGap: "0.75rem", // 2cards
	},
	/*iphone 14 pro max - 430*/
	[theme.breakpoints.up(theme.breakpoints.values.xs + 149)]: {
		// gap: "0.5rem", // 3 cards
		// rowGap: "0.75rem", //3 cards
		gap: "1rem", // 2 cards
		rowGap: "1rem", // 2 cards
	},
	/* XSPLUS breakpoint */
	// [theme.breakpoints.up("xsPlus")]: {
	// 	padding: "0rem 1.5rem 0rem 1.5rem",
	// },
	/* SM breakpoint */
	// [theme.breakpoints.only("sm")]: {
	// 	padding: "0rem 3rem 0rem 3rem",
	// },
	[theme.breakpoints.up("sm")]: {
		padding: "0rem ",
	},
	/* MD breakpoint */
	[theme.breakpoints.up(theme.breakpoints.values.md + 147)]: {
		gap: "1rem",
		rowGap: "1rem",
	},
	[theme.breakpoints.up("md1190")]: {
		width: "100%",
	},
}));

const LoadMoreDiv = styled("div")(({ theme }) => ({
	width: "100%",
	height: "3.5rem",
	pointerEvents: "none",
	cursor: "none",
	background: "transparent",
	alignItems: "center",
}));

const SuggestedPropertiesScorll = ({
	search_filter_state,
	dispatch,
	transaction_type,
	property_type,
	property_category,
	location_title,
	location_coordinates,
	redux_session,
	profile_context,
	search_filter_metrices,
	search_api_response,
	slug_id,
	property_title,
	login_flow_global_state,
}: {
	search_filter_state: StateInterface["search_filters_state"];
	dispatch: Function;
	transaction_type: string;
	property_type: string;
	property_category: string;
	location_title: string;
	location_coordinates: Array<number>;
	redux_session: StateInterface["redux_session"];
	profile_context: StateInterface["profile_context"];
	search_filter_metrices: StateInterface["search_filter_metrices"];
	search_api_response: StateInterface["SeacrhApiResponse"];
	slug_id: string;
	property_title: string;
	login_flow_global_state: StateInterface["login_flow_global_state"];
}) => {
	const theme = useTheme();

	const router = useRouter();

	/* Translations */

	const localLang = {
		similar_properties:
			router.locale === "ar-AE" ? "عقارات مشابهة" : router.locale === "kn-IN" ? "ಸಮಾನ ಆಸ್ತಿ" : "Similar Properties",
	};

	const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
	/*

	* state to store propertyids to render property cards

	*/

	const [PropertyIds, setPropertyIds] = React.useState<any[]>([]);
	/*

	* ref passed to loadmorediv when inview trigger searchthunk

	*/

	const { ref, inView } = useInView({ threshold: 0.1 });
	/*

	* setting initial load state to trigger dispatches only once

	*/

	const [intitialLoad, setIntitalLoad] = React.useState(true);

	/*

	* show spinner or show end of results message

	*/

	const [spinnerTrigger, setSpinnerTrigger] = React.useState(true);

	/*

	* setting default triggers matching propertytype and location from the SPP slug for search filters and dispatching the same

	*/
	const TriggerDispatches = () => {
		dispatch(
			updateSearchFilterSelectedOptionsThunk({
				searchFilterId: "location",
				newOptions: [
					{
						id: "location",
						title: "Location",
						value: {
							title: location_title,
							coordinates: [location_coordinates[0], location_coordinates[1]],
						},
					},
				],
			}),
		);
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "location", isApplied: true }));

		dispatch(
			updateSearchFilterSelectedOptionsThunk({
				searchFilterId: "transaction_type",
				newOptions: [
					{
						id: transaction_type,
						title: transaction_type.charAt(0).toUpperCase() + transaction_type.slice(1),
						value: transaction_type,
					},
				],
			}),
		);
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "transaction_type", isApplied: true }));

		dispatch(
			updateSearchFilterSelectedOptionsThunk({
				searchFilterId: "search_type",
				newOptions: [{ id: "properties", title: "Properties", value: "properties" }],
			}),
		);
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "search_type", isApplied: true }));

		dispatch(
			updateSearchFilterSelectedOptionsThunk({
				searchFilterId: "property_category",
				newOptions: [
					{
						id: property_category,
						title: property_category.charAt(0).toUpperCase() + property_category.slice(1),
						value: property_category,
					},
				],
			}),
		);
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_category", isApplied: true }));

		dispatch(
			updateSearchFilterSelectedOptionsThunk({
				searchFilterId: "property_type",
				newOptions: [
					{
						id: property_type?.charAt(0).toLowerCase() + property_type?.slice(1),
						title: property_type,
						value: property_type,
					},
				],
			}),
		);
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_type", isApplied: true }));
		setIntitalLoad(false);
	};

	const [page_number, setPageNumber] = React.useState(1);

	React.useEffect(() => {
		if (intitialLoad) {
			if (
				transaction_type !== "" &&
				property_type !== "" &&
				property_type !== "" &&
				location_title !== "" &&
				location_coordinates[0] !== undefined &&
				location_coordinates[1] !== undefined
			) {
				TriggerDispatches();
			}
		}
		if (inView && !intitialLoad) {
			/*

			* after setting searchfilter state. we dispatch and pass it down to builddatabasequeries

			*/
			const db_queries = buildDatabaseQueries(search_filter_state);

			if (db_queries === undefined) return;

			dispatch(
				fetchSearchThunk({
					db_queries: db_queries,
					page_number: page_number,
					page_size: process.env.SEARCH_RESULTS_DEFAULT_PAGE_SIZE,
					search_filter_metrices: search_filter_metrices,
					session_id: redux_session?.session_id?.toString() || "",
					user_id: redux_session?.user?.dbUser?._id || "",
					profile_context: redux_session ? profile_context : null,
					sort_field: "distance",
				}),
			);

			setPageNumber((prev) => prev + 1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inView, intitialLoad]);

	/*

	* if search api response is not undefined we set propertyids to render property cards

	*/

	React.useEffect(() => {
		if (search_api_response && slug_id !== "") {
			/*

			* filtering out the current property from the search api response and setting the propertyids to render property cards

			*/
			setPropertyIds((prevIds) =>
				Array.from(
					new Set([
						...prevIds,
						...search_api_response?.non_boosted.filter((id) => id !== slug_id),
						...search_api_response?.boosted.filter((id) => id !== slug_id),
						...search_api_response?.boosted_from_other_locations.filter((id) => id !== slug_id),
					]),
				),
			);
		}
		/*

		* if search api response is not undefined and all arrays are empty we set spinner trigger to false and display end of results message

		*/
		if (
			search_api_response !== undefined &&
			search_api_response.boosted.length === 0 &&
			search_api_response.non_boosted.length === 0 &&
			search_api_response.boosted_from_other_locations.length === 0
		) {
			setSpinnerTrigger(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search_api_response]);

	/*

	* mapping through propertyids to render property cards

	*/

	const ComponentToRender = PropertyIds.map((propertyId: any, key: any) => {
		return (
			<PropertyCardGridView
				source="listing_page"
				PropertyId={propertyId}
				dispatch={dispatch}
				session={redux_session}
				profile_context={profile_context}
				key={key}
				login_flow_global_state={login_flow_global_state}
			/>
		);
	});

	return (
		<React.Fragment>
			<RowDiv>
				<div>
					{!intitialLoad && (
						<Typography
							variant="subtitle2"
							sx={{
								fontWeight: 500,
								fontSize: "0.875rem",
								lineHeight: "1.25rem",
								color: "#212121",
								[theme.breakpoints.up("md1190")]: {
									fontSize: "1.25rem",
									lineHeight: "1.5rem",
									padding: "0rem 0rem 0.5rem 0.25rem",
								},
							}}
						>
							{localLang.similar_properties}
						</Typography>
					)}
				</div>
				<DesktopFilterDivSomething>
					{ComponentToRender}
					{spinnerTrigger ? (
						<div style={{ width: "100%" }}>
							<LoadMoreDiv ref={ref}>
								<Box
									sx={{
										display: "flex",
										justifyContent: "center",
										width: "100%",
										height: "100%",
										padding: "1.5rem 0rem 0rem 0rem",
									}}
								>
									<CircularProgress size={smDown ? 25 : 35} />
								</Box>
							</LoadMoreDiv>
						</div>
					) : (
						<div
							style={{
								display: "flex",
								justifyContent: "center",
								width: "100%",
								height: "100%",
								padding: "1rem",
							}}
						>
							<Typography>That&apos;s all we&apos;ve got for now</Typography>
						</div>
					)}
				</DesktopFilterDivSomething>
			</RowDiv>
		</React.Fragment>
	);
};

export default SuggestedPropertiesScorll;
